import * as yup from 'yup';
import UserPresenter from 'presenters/UserPresenter';

const validationFields = {
  email: yup
    .string()
    .email('validations.realEstateAgentProfile.email.invalid')
    .required('validations.realEstateAgentProfile.email.required')
    .max(50, 'validations.realEstateAgentProfile.email.maxLength'),
  firstName: yup
    .string()
    .max(50, 'validations.realEstateAgentProfile.firstName.maxLength')
    .nullable(),
  lastName: yup
    .string()
    .max(50, 'validations.realEstateAgentProfile.lastName.maxLength')
    .nullable(),
  phoneNumber: yup.string().nullable(),
  company: yup
    .string()
    .max(50, 'validations.realEstateAgentProfile.company.maxLength')
    .nullable(),
  mls: yup.string().required('validations.realEstateAgentProfile.mls.required'),
  aboutMe: yup.string().nullable(),
};

export const getDefaultAttributes = user => {
  return {
    email: UserPresenter.email(user),
    firstName: UserPresenter.firstName(user) || '',
    lastName: UserPresenter.lastName(user) || '',
    mls: UserPresenter.mls(user),
    company: UserPresenter.company(user) || '',
    phoneNumber: UserPresenter.phoneNumber(user) || '',
    aboutMe: UserPresenter.aboutMe(user) || '',
    city: UserPresenter.city(user) || '',
    state: UserPresenter.state(user) || '',
    zipCode: UserPresenter.zipCode(user) || '',
    streetAddress1: UserPresenter.streetAddress1(user) || '',
    streetAddress2: UserPresenter.streetAddress2(user) || '',
    lat: UserPresenter.lat(user) || '',
    lng: UserPresenter.lng(user) || '',
  };
};

export default yup.object().shape({ ...validationFields });



// WEBPACK FOOTER //
// ./src/forms/realEstateAgentProfileForm.js